<ng-container *transloco="let convert;">
  <div
    class="modal micromodal-slide"
    [id]="modalId"
    aria-hidden="true"
    tabindex="-1"
    aria-labelledby="dialog-child-name">
    <div class="modal__overlay" tabindex="-1">
      <div
        class="modal__container modal--multi-vin"
        role="dialog"
        aria-modal="true"
        aria-labelledby="multi-vin-modal-title"
        [attr.data-track-region]="dialogHeadline">
        <header class="modal__header">
          <h1 class="modal__title fw-normal" id="multi-vin-modal-title" tabindex="-1">
            {{ dialogHeadline }}
          </h1>
        </header>

        <div class="modal__content">
          <div class="modal__body">

            <!-- Search By -->
            <div [attr.data-track-region]="dialogHeadline" class="form-group">
              <label>{{convert('sellModule.manageInventory.multiVinModal.textSearchBy')}}</label>

              <div class="control-wrapper my-3" [formGroup]="multiVinForm">
                <div class="custom-control custom-radio mt-3">
                  <input [value]="ActionSelection.Vin" data-track-name="VIN" formControlName="action" data-track-elem="radio" type="radio" id="action-vin" name="action" class="custom-control-input">
                  <label class="custom-control-label" for="action-vin">{{textVin}}</label>
                </div>
                <div class="custom-control custom-radio mt-3">
                  <input [value]="ActionSelection.Stock" [attr.data-track-name]="stockMvaReference()" formControlName="action" data-track-elem="radio" type="radio" id="action-stock" name="action" class="custom-control-input">
                  <label class="custom-control-label" for="action-stock">{{textStockNumber}}</label>
                </div>
              </div>
            </div>

            <p [innerHTML]="convert('sellModule.manageInventory.multiVinModal.textEnterFullLabelAction', {labelAction:labelAction})"></p>

            <!-- Multiple Entries Form -->
            <form name="multiVinForm" [formGroup]="multiVinForm" novalidate allytm-async>
              <div class="d-flex flex-column app-textarea">
                <textarea
                  id="multi-vin-textarea"
                  cols="60"
                  rows="8"
                  (input)="onInput()"
                  formControlName="entries"
                  class="form-control"
                  [class.invalid]="hasEntriesError"
                  aria-label="Multi vin textarea"
                  >
                </textarea>

                <div
                  class="alert alert-danger mt-2 fw-bold"
                  [attr.aria-hidden]="!hasEntriesError"
                  aria-live="polite"
                  aria-atomic="true"
                  role="alert">

                  @if (hasEntriesError) {
                    <span>
                      {{convert('sellModule.manageInventory.multiVinModal.textExceeded')}}
                      {{ entriesErrorCount }}
                    </span>
                  }
                </div>
              </div>

              <div class="modal__actions">
                <button
                  class="btn btn-primary me-md-2 mb-3 mb-md-0"
                  (click)="onSubmit()"
                  data-track-elem="button"
                  data-track-name="Search">
                  {{convert('common.labelSearch')}}
                </button>
                <button class="btn btn-outline-primary" (click)="clearInput()">
                  <span>{{convert('sellModule.manageInventory.multiVinModal.btnClear')}}</span>
                </button>
              </div>
            </form>
          </div>
        </div>

        @if (configuration) {
          <button
            class="modal__close"
            [attr.aria-label]="convert('common.modalClose')"
            (click)="closeMicroModal()"
            data-track-elem="icon"
            data-track-name="Close"
            data-track-trigger="close">
            <img
              src="../../../ui/assets/assets-{{ configuration.tenantName }}/{{ configuration.tenantName }}-close.svg"
              alt="{{convert('common.altCloseModelIcon')}}" />
          </button>
        }
      </div>
    </div>
  </div>
</ng-container>
